<template>
  <div>
    <div v-for="(row, key) in rows" :key="key" class="row">
      <div
        v-for="image in sliceImages(row)"
        :key="image.id"
        :class="'col-sm-12 col-lg-' + col + ' pl-0 pr-0 text-center'"
      >
        <img
          class="gallery-image"
          :src="image.small_image_src"
          :data-gallery-src="image.big_image_src"
          :data-gallery-id="image.id"
          data-type="gallery"
          @click="openGallery(image)"
        />
      </div>
    </div>

    <div
      v-show="showGallery"
      id="image-preview-overlay"
      class="image-preview-overlay"
    />

    <div v-show="showGallery" id="image-preview-div" class="image-preview">
      <div class="image-preview-container">
        <i
          class="fa fa-arrow-circle-left gallery-icon gallery-icon__prev"
          @click="previousImage"
        />
        <i
          class="fa fa-times-circle gallery-icon gallery-icon__close"
          @click="closeGallery"
        />
        <i
          class="fa fa-arrow-circle-right gallery-icon gallery-icon__next"
          @click="nextImage"
        />
        <div v-if="currentImage && showGallery" id="image-preview-container">
          <img
            id="image-preview-container__img"
            :src="currentImage.big_image_src"
            class="image-preview-container__img"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ImageGallery",
  props: {
    images: {
      type: Array,
      required: true,
    },
    config: {
      type: Object,
      required: false,
      default: () => {
        return {
          columns: 12,
        };
      },
    },
  },
  data() {
    return {
      rows: [1],
      col: 12,
      currentImage: null,
      showGallery: false,
    };
  },
  mounted() {
    this.calculateConfig();
    this.numberImages(1);
  },
  methods: {
    calculateConfig() {
      let n = this.images.length / this.config.columns;
      this.rows = Array.from({ length: n }, (v, k) => k + 1);
      this.col = 12 / this.config.columns;
    },
    sliceImages(row) {
      let f = row > 1 ? (row - 1) * this.config.columns : 0;
      return this.images.slice(f, f + this.config.columns);
    },
    numberImages(startFrom) {
      this.images.map((image) => {
        image.id = startFrom;
        startFrom++;
      });
    },
    openGallery(image) {
      window.addEventListener("keyup", (event) => {
        switch (event.keyCode) {
          case 37:
            return this.previousImage();
          case 39:
            return this.nextImage();
          case 27:
            return this.closeGallery();
        }
      });

      this.showGallery = true;
      this.currentImage = image;
    },
    nextImage() {
      let nextId =
        this.currentImage.id === this.images.length
          ? 1
          : this.currentImage.id + 1;
      this.currentImage = this.images.filter((image) => image.id === nextId)[0];
    },
    previousImage() {
      let previousId =
        this.currentImage.id === 1
          ? this.images.length
          : this.currentImage.id - 1;
      this.currentImage = this.images.filter(
        (image) => image.id === previousId
      )[0];
    },
    closeGallery() {
      window.removeEventListener("keyup", (event) => {
        switch (event.keyCode) {
          case 37:
            return this.previousImage();
          case 39:
            return this.nextImage();
          case 27:
            return this.closeGallery();
        }
      });

      this.currentImage = null;
      this.showGallery = false;
    },
  },
};
</script>
